export default "__VITE_ASSET__CX9VpUDA__"